import { ButtonERP } from "@finanedi.es/storybook"
import { useActivoById } from "api/Activo.hook"
import { updateActivo } from "api/Activo.service"
import { UpdateActivoCommandProps } from "api/Commands/UpdateActivoCommand"
import { TIPO_INMOVILIZADO } from "api/Types/TipoInmobilizado"
import notification from "common/utils/notification"
import { Formik } from "formik"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import { AssetDetail } from "./AssetDetail"
import { OtherDetail } from "./OtherDetail"
import { ProviderDetail } from "./ProviderDetail"

export const TabDetallesGenerales = () => {
  const { t } = useTranslation()
  const { activoId } = useParams<{ activoId: string }>()
  const { activoByIdData, activoByIdRefetch } = useActivoById(activoId)

  return (
    <Formik
      initialValues={{
        nombre: activoByIdData?.nombre,
        fechaAdquisicion: activoByIdData?.fechaAdquisicion,
        tipoInmovilizado:
          activoByIdData?.tipoInmovilizado === TIPO_INMOVILIZADO.MATERIAL
            ? t("nsAssets.tabDetails.material")
            : activoByIdData?.tipoInmovilizado === TIPO_INMOVILIZADO.INTANGIBLE
            ? t("nsAssets.tabDetails.intangible")
            : "",
        numeroCuentaContable: activoByIdData?.numeroCuentaContable,
        numeroCuentaContableContrapartida:
          activoByIdData?.numeroCuentaContableContrapartida,
        descripcion: activoByIdData?.descripcion,

        numeroSerie: activoByIdData?.numeroSerie,
        numeroInventario: activoByIdData?.numeroInventario,
        codigoBarras: activoByIdData?.codigoBarras,
        marca: activoByIdData?.marca,
        modelo: activoByIdData?.modelo,

        proveedor: {
          factura: activoByIdData?.proveedor?.factura,
          nif: activoByIdData?.proveedor?.nif,
          razonSocial: activoByIdData?.proveedor?.razonSocial,
        },
      }}
      onSubmit={(values) => {
        const requestBody: UpdateActivoCommandProps = {
          id: activoId ?? "",
          codigoBarras: values?.codigoBarras,
          descripcion: values?.descripcion,
          marca: values?.marca,
          modelo: values?.modelo,
          nombre: values?.nombre,
          numeroInventario: values?.numeroInventario,
          numeroSerie: values?.numeroSerie,
        }
        updateActivo(requestBody).then(() => {
          notification.success()
          activoByIdRefetch()
        })
      }}
    >
      {({ values, errors, touched, handleChange, handleSubmit }) => (
        <div
          key='Detalles generales'
          className='tw-w-full tw-bg-white tw-mt-8 tw-rounded tw-shadow-sm tw-p-6'
        >
          <section className='tw-grid tw-gap-y-5 tw-text-text'>
            <AssetDetail
              errors={errors}
              handleChange={handleChange}
              touched={touched}
              values={values}
              t={t}
            />
            <OtherDetail
              errors={errors}
              handleChange={handleChange}
              touched={touched}
              values={values}
              t={t}
            />
            <ProviderDetail
              handleChange={handleChange}
              values={values}
              t={t}
            />
            <ButtonERP
              label={`${t("nsAssets.tabDetails.save")}`}
              onClick={() => handleSubmit()}
              customize={{
                type: "primary",
                size: "md",
              }}
              className='tw-w-fit'
            />
          </section>
        </div>
      )}
    </Formik>
  )
}
